import { BrandColorType } from './types'

const brandColors: BrandColorType = {}

export default brandColors
